var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"la",attrs:{"target":_vm.target,"href":_vm.href},on:{"click":function($event){$event.stopPropagation();return _vm.gotoURL.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }